import { DefaultTheme } from "styled-components";

export const borderGradient = (theme: DefaultTheme) => {
  return `
  linear-gradient(${theme.colors.bg}, ${theme.colors.bg}) padding-box,
  linear-gradient(to right, ${theme.colors.secondary[500]}, ${theme.colors.tertiary[500]}) border-box;
  `;
};
